
export const STATUS = {
    IDLE : "IDLE" , 
    LOADDING : "LOADING" ,
    SUCCESS :"SUCCESS" , 
    ERROR : "ERROR" , 
    UNAUTHORIZED : "UNAUTHORIZED"
}

// export const DomainName = `http://localhost:4000/api/v1` ;
// export const PythonDomain = `http://127.0.0.1:5000/search` ; 
// export const PHP_DOMAIN = `https://token.rbm.tools/token_litev2.php` // Wait until Done 


export const DomainName = `https://backend.rbm.tools/api/v1` ;
export const PythonDomain = `https://flask.rbm.tools/search` ; 
export const PHP_DOMAIN = `https://token.rbm.tools/token_litev2.php` // Wait until Done 



export const LIMIT_USER = 20 ; 
export const LIMIT_MESSAGE = 90 ; 
export const GROUP_LIMIT = 500 ;